import React, { Component } from 'react';
import moment from 'moment/moment';
export default class Footer extends Component {
    render() {
        return (
            <div className=" text-center Copyright-2020-Universal-Health-Fellowship-All" style={{marginTop:'-15px'}}>
                Copyright © {moment().format("YYYY")} curamLife. All rights reserved. | Powered by curamLife
            </div>
        )
    }
}

